import React, { useEffect, useState } from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';
import createRegex from "core-module/tiny-functions/createRegex";

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../../styles.js"

const PhoneInputComponent = props => {
  const { classes } = props;

  const mountedRef = useMountedRef();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if(mountedRef.current){
            setError(getError(phoneNumber))
            props.handlePhoneChange(phoneNumber, getError(phoneNumber))
        }
    }, [phoneNumber])

  let handleChange = (value) => {
        setPhoneNumber(correctPhoneNumber(value))
  }

  let correctPhoneNumber = (value) => {
    let newPhoneNumber = "(";
    let j=0;

    for (var i=0; i<value.length; i++){
        if(i==0) {
            if(value[i] == '(') {
                newPhoneNumber = value[i]
            }
            else {
                newPhoneNumber = newPhoneNumber + value[i];
            }
        }
        else if(i==4) {
            if(value[i] == ")"){
                newPhoneNumber = newPhoneNumber + value[i];
            }
            else {
                newPhoneNumber = newPhoneNumber + ") " +value[i]
            }
        }
        else if(i==9) {
            if(value[i] == '-'){
                newPhoneNumber = newPhoneNumber + value[i];
            }
            else {
                newPhoneNumber = newPhoneNumber + "-" +value[i]
            }
        }
        else if(i>=14) {
            newPhoneNumber = newPhoneNumber;
            setErrorMessage("Max number of characters")
        }
        else {
            newPhoneNumber = newPhoneNumber + value[i];
        }
    }
    document.getElementById(props.id).value = newPhoneNumber === "(" ? "" : newPhoneNumber;
    return newPhoneNumber === "(" ? "" : newPhoneNumber
    }

    let getError = (value) => {
        if(checkIfBlank(value))
            return true
        else if (!checkAcceptedFormat(value))
            return true
        else 
            return false
    }
  
    let checkAcceptedFormat = (value) => {
        let isAccepted = createRegex(props.apiRegex.phonennumber.regex).test(value)
        if(!isAccepted)
            setErrorMessage("Expected format: (123) 456-7890")
        return isAccepted
         
    }

    let checkIfBlank = (value) => {
        if(value == "" || value == null) {
            setErrorMessage("Field cannot be blank")
            return true
        } else {
                setErrorMessage("")
                return false
            }
    }


  return (
    <div>
        <GridContainer className={classes.containerLine}> 
            <GridItem xs={6}>
                <FormLabel className={classes.labelHorizontal}>
                    {props.phoneInputText}
                </FormLabel>
            </GridItem>
            <GridItem xs={6}>
                <TextField
                    id={props.id}
                    label="Required"
                    onChange={(event) => {
                            handleChange(event.target.value)
                        }
                    }
                    className={classes.txtField}
                    error={isError}
                    />
                {errorMessage}
            </GridItem>
        </GridContainer>
    </div>
  );
};

export default withStyles(styles)(PhoneInputComponent);

const useMountedRef = () => {
    const mountedRef = React.useRef(false);
  
    React.useEffect(() => {
      setTimeout(() => {
        mountedRef.current = true;
      });
    }, []);
  
    return mountedRef;
  };